/**
 * Featured Completions — owner-curated highlights on the NoJo Enterprise
 * homepage. Per owner directive (Feb 2026): keep the list short and
 * focused — only the four highest-impact items so the homepage doesn't
 * stretch. Order is deliberate (left-to-right):
 *
 *   1. Five-Model AI Team           (NoJo internal)
 *   2. Toll Explorer                (JapanETCcard)
 *   3. Toll Guides Library          (JapanETCcard)
 *   4. #1 on Google · AI Overview   (JapanTollReceipts)
 *
 * Each entry intentionally carries a `tone` and `iconKey` so the homepage
 * card can render a clean branded visual without depending on screenshot
 * images we don't have. `href` is the LIVE external page on the sister
 * site (the "See it live" destination). `internalHref` overrides it when
 * the destination is on NoJo itself (e.g. Five-Model AI Team → /our-team).
 */

export const FEATURED_COMPLETIONS = [
  {
    id: "five-model-ai-team",
    service: "shared",
    tone: "#0F1D2D",
    accentText: "#7AB8E8",
    categoryEn: "AI Team",
    categoryJa: "AIチーム",
    iconKey: "Cpu",
    titleEn: "Five-Model AI Team",
    titleJa: "5モデル体制のAIチーム",
    summaryEn:
      "Five AI models work together as one backbone — MEISAI extraction, bilingual translation, quality review, smart alerts and operations oversight.",
    summaryJa:
      "MEISAIデータ確認、日英翻訳、品質レビュー、スマートアラート、運用監督を支える5つのAIワークフロー。",
    internalHref: "/our-team",
    href: null,
    ctaEn: "Meet the team",
    ctaJa: "AI支援ワークフローを見る",
  },
  {
    id: "toll-explorer",
    service: "japanetccard",
    tone: "#5B2E83",
    accentText: "#FFFFFF",
    categoryEn: "Reports & Usage",
    categoryJa: "レポート・利用状況",
    iconKey: "Map",
    titleEn: "Toll Explorer",
    titleJa: "Toll Explorer",
    summaryEn:
      "Visualize every toll, every route, every interchange across Japan — search and compare on an interactive map.",
    summaryJa:
      "日本全国の通行料金・ルート・インターチェンジを、インタラクティブな地図で検索・比較できます。",
    href: "https://japancardetc.com/toll-explorer",
    // Toll Explorer is an English-only sister-site page; do NOT inject
    // a `/ja` prefix for visitors browsing the JA version of NoJo, or
    // the destination 404s.
    noLangMirror: true,
  },
  {
    id: "toll-guides-library",
    service: "japanetccard",
    tone: "#0E5FB0",
    accentText: "#FFFFFF",
    categoryEn: "Customer Experience",
    categoryJa: "カスタマー体験",
    iconKey: "FileText",
    titleEn: "Toll Guides Library",
    titleJa: "Toll Guides ライブラリ",
    summaryEn:
      "Bilingual step-by-step guides covering every common driver question in Japan — written from real customer tickets.",
    summaryJa:
      "日本でのドライバーがよく抱える疑問を、日英ステップバイステップで解説。実際のお客様の問い合わせをもとに作成しています。",
    // Owner-confirmed canonical URL (Feb 2026): Toll Guides Library lives
    // on JapanETCcard, not JapanTollReceipts. Single path serves both EN
    // and JA on the destination site (no /ja mirror exists).
    href: "https://japancardetc.com/toll-guides",
    noLangMirror: true,
  },
  {
    id: "google-rank-ai-overview",
    service: "japantollreceipts",
    tone: "#F59E0B",
    accentText: "#0F1D2D",
    categoryEn: "SEO & Reach",
    categoryJa: "SEO・到達範囲",
    iconKey: "Sparkles",
    titleEn: "#1 on Google · AI Overview Cited",
    titleJa: "Google 検索1位 · AI Overview に引用",
    summaryEn:
      "20+ bilingual guides in the Guides Hub — authority depth that earned a #1 Google ranking and a Google AI Overview citation.",
    summaryJa:
      "20本以上の日英バイリンガルガイドが認知され、Google検索1位とAI Overviewへの引用を獲得しています。",
    href: "https://japantollreceipts.jp/en/guides/list",
    // Same canonical URL as Toll Guides Library — no /ja mirror exists.
    noLangMirror: true,
  },
];
